// Laedt die oeffentliche Auth-Config vom Backend (/auth/config). Bestimmt, ob das
// Frontend den Demo-Login oder den Microsoft-Entra-Login (MSAL) zeigt. KEINE Secrets.

import { api } from "../lib/api.js";

export interface AuthPublicConfig {
  strategy: "demo" | "entra";
  entra?: {
    clientId: string;
    tenantId: string;
    /** MSAL-Token-Scope, z.B. api://<client-id>/.default */
    scope: string;
    /** "web" = serverseitiger Login-Redirect (/auth/login), "spa" = Browser-MSAL/PKCE. */
    mode: "web" | "spa";
  };
}

export function fetchAuthConfig(): Promise<AuthPublicConfig> {
  return api.get<AuthPublicConfig>("/auth/config");
}
